import { getLegacyDesignTarget } from '~/utils/legacyDesignRoute';

// Только legacy-фронт. Удалить вместе с картой адресов и pendingGuestTransfers после эксперимента.
export const useLegacyDesignSwitch = () => {
  if (import.meta.server) return;

  const commonStore = useCommonStore();
  const userStore = useUserStore();
  const config = useRuntimeConfig();
  let switching = false;
  const hasCookie = () => document.cookie.split(';').some((part) => part.trim() === 'newdesign=1');

  onNuxtReady(() => {
    watch(
      () => [
        commonStore.newDesign,
        userStore.authorized,
        commonStore.pendingGuestTransfers,
        commonStore.guestTransferFailed,
      ],
      () => {
        if (switching || !commonStore.newDesign || !userStore.authorized || commonStore.pendingGuestTransfers) return;
        if (commonStore.guestTransferFailed) return;
        if (hasCookie()) return;

        const target = getLegacyDesignTarget(window.location.href);
        const secure = config.public.siteEnvironment !== 'dev' ? '; Secure' : '';
        // Прямая синхронная запись: cookie уже доступна прокси до следующего document request.
        document.cookie = `newdesign=1; Path=/; Max-Age=${180 * 24 * 60 * 60}; SameSite=Lax${secure}`;
        if (!hasCookie()) return; // Браузер запретил cookie: не создаём цикл reload.

        switching = true;
        // replace того же URL с #якорем может быть только same-document navigation.
        if (new URL(target, window.location.href).href === window.location.href) window.location.reload();
        else window.location.replace(target);
      },
      { immediate: true, flush: 'post' },
    );
  });
};
